// Qué formatos acepta el video de PLANTILLA — ADR-2026-09-14-el-video-de-plantilla-solo-
// ofrece-los-formatos-que-kling-acepta.
//
// El pipeline de las plantillas de video corre sobre Kling
// (`kling-v3-image-to-video`), y ese modelo acepta TRES relaciones de aspecto: 16:9, 9:16
// y 1:1. Cualquier otra vuelve como
// `invalid aspect_ratio: 4:5 (model kling-v3-image-to-video only supports ...)` — un 400
// de Evolink que mata la generación entera, porque el video no tiene cadena de fallback.
//
// Pasó cuatro veces en 30 días, siempre con la misma plantilla y siempre con 4:5. La causa
// no era que el usuario eligiera raro: `formatoVal` es UNO solo para toda la Interfaz y se
// arrastra entre modos, así que quien venía de generar imágenes en 4:5 entraba a la
// plantilla de video con 4:5 puesto y sin haber tocado nada.
//
// Por eso no alcanza con filtrar la lista del picker: hay que CORREGIR el valor que quedó
// arrastrado. Las dos cosas salen de acá.

/** Los tres que acepta Kling, en slugs de `FORMAT_OPTIONS_V2`. */
export const SLUGS_VIDEO_PLANTILLA = ['banner', 'story', 'square'] as const;

/**
 * El que se usa cuando el arrastrado no sirve. 9:16 es el vertical de redes y el mismo
 * default que ya tiene "Animar imagen" (`buildAnimarVideoBody` manda `Format: '9:16'`
 * fijo), así que un usuario que no elige nada obtiene lo mismo en los dos caminos.
 */
export const FORMATO_VIDEO_PLANTILLA_DEFECTO = 'story';

export const esFormatoDeVideoPlantilla = (slug: string | null | undefined): boolean =>
  !!slug && (SLUGS_VIDEO_PLANTILLA as readonly string[]).includes(slug);

/**
 * El formato con el que se puede generar una plantilla de video: el elegido si Kling lo
 * acepta, y si no el default. `null` (nada elegido todavía) también cae al default: el
 * pedido tiene que llevar uno de los tres sí o sí.
 */
export const formatoParaVideoPlantilla = (slug: string | null | undefined): string =>
  esFormatoDeVideoPlantilla(slug) ? (slug as string) : FORMATO_VIDEO_PLANTILLA_DEFECTO;
